import { ApolloError, gql, useMutation } from "@apollo/client"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import * as Yup from 'yup';
import { Box, Card, Flex, Heading, Button, Text } from "rebass/styled-components"
import styled from "styled-components"
import FullLayout2 from "../components/FullLayout"
import Header from "../components/Header"
import { IOkPayload } from "../graphql/types/mutations/generics"
import { Form, Formik } from "formik";
import FormField from "../components/FormField";
import TextInput from "../components/TextInput";
import { OtpInner } from "./login/OtpInner";

// console.log('uid', uid);
const schema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
});
const schema2 = Yup.object().shape({
  password: Yup.string()
    .trim()
    .min(8, 'Password must be greater than 8 characters')
    .required('Required'),
  passwordConfirm: Yup.string()
    .trim()
    .min(8, 'Password must be greater than 8 characters')
    .required('Required'),
});

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto !important;
`;

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

const CHECK_LOCKED_ACCOUNT_UID = gql`
  mutation providerCheckLockedAccountUid($uid: String!) {
    providerCheckLockedAccountUid(uid: $uid) {
      ok
    }
  }
`

const CHECK_UNLOCK_VALUES = gql`
  mutation providerCheckUnlockValues($uid: String!, $email: String!, $otp: String) {
    providerCheckUnlockValues(uid: $uid, email: $email, otp: $otp) {
      ok
    }
  }
`;

const UNLOCK_ACCOUNT = gql`
  mutation providerUnlockAccount($uid: String!, $email: String!, $password: String!) {
    providerUnlockAccount(uid: $uid, email: $email, password: $password) {
      ok
    }
  }
`;

interface ICheckLockedAccountUidOutput {
  providerCheckLockedAccountUid: IOkPayload
}

interface ICheckLockedAccountUidInput {
  uid: string
}

interface ICheckUnlockValuesOutput {
  providerCheckUnlockValues: IOkPayload
}

interface ICheckUnlockValuesInput {
  uid: string,
  email: string,
  otp?: string
}

interface IUnlockAccountOutput {
  providerUnlockAccount: IOkPayload
}

interface IUnlockAccountInput {
  uid: string,
  email: string,
  password: string
}

const UnlockAccount = () => {
  const { uid } = useParams()
  const navigate = useNavigate()
  const [mustEnterOtp, setMustEnterOtp] = useState(false);
  const [storedData, setStoredData] = useState<any>(null);
  const [isValuesChecked, setIsValuesChecked] = useState(false)
  const [isOriginalCheckComplete, setIsOriginalCheckComplete] = useState(false)
  const [invalidUid, setInvalidUid] = useState(false)
  const [checkUid, { loading: loadingCheckUid }] = useMutation<ICheckLockedAccountUidOutput, ICheckLockedAccountUidInput>(CHECK_LOCKED_ACCOUNT_UID)
  const [checkUnlockValues, { loading: loadingCheckUnlockValues }] = useMutation<ICheckUnlockValuesOutput, ICheckUnlockValuesInput>(CHECK_UNLOCK_VALUES)
  const [unlock, { loading: loadingUnlock }] = useMutation<IUnlockAccountOutput, IUnlockAccountInput>(UNLOCK_ACCOUNT)


  const initialCheck = async () => {
    if (!uid) {
      navigate('/');
      return
    }

    try {
      const res = await checkUid({
        variables: {
          uid
        }
      })

      // console.log('RES', res)
      if (!res.data || !res.data.providerCheckLockedAccountUid || !res.data.providerCheckLockedAccountUid.ok) {
        setIsOriginalCheckComplete(true)
        setInvalidUid(true)
      } else {
        setIsOriginalCheckComplete(true)
      }
    } catch (error) {

      console.log('RES error', error)
    }
  };

  useEffect(() => {
    initialCheck()
  }, [])

  const handleSubmit = async (values: any) => {
    try {
      if (!values.otp) {
        setStoredData({ ...values });
      }
      await checkUnlockValues({
        variables: { ...values, uid },
      });
      setIsValuesChecked(true)
    } catch (error: any) {
      if (error.message.toLowerCase() === 'error: otp req') {
        setMustEnterOtp(true);
        return;
      }

      if (!error.graphQLErrors) {
        return;
      }

      error.graphQLErrors.forEach((e: ApolloError) => {
        toast.error(e.message, {
          autoClose: 3000
        });
      });
    }
  };

  const handleSubmitReactivate = async (values: any) => {
    
    if (!values.password) {
      toast.error('Invalid Password', {
        autoClose: 3000
      });
      return;
    }
    if (!values.passwordConfirm) {
      toast.error('Invalid Password Confirm', {
        autoClose: 3000
      });
      return;
    }
    if (values.password !== values.passwordConfirm) {
      toast.error(`Password Confirm doesn't match`, {
        autoClose: 3000
      });
      return;
    }

    try {
      const { data } = await unlock({
        variables: { ...values, email: storedData.email, uid },
      });
      // console.log('LOGIN', data);
      // const attemptedRoute = localStorage.getItem('route');
      // localStorage.setItem('token', data.login.token);
      // analytics.identify(data.login.user.id);
      
      toast.success('Account Unlocked', {
        autoClose: 3000
      });
      navigate('/');
    } catch (error: any) {
      if (!error.graphQLErrors) {
        return;
      }

      error.graphQLErrors.forEach((e: ApolloError) => {
        // console.log(error);
        toast.error(error.message, {
          autoClose: 3000
        });
      });
    }
  };
  console.log({
    isOriginalCheckComplete,
    isValuesChecked,
    invalidUid,

  })

  if (!isOriginalCheckComplete) {
    return (
      <>
        <Container>
          <Flex flex={1}>
            <Header dark={false} />
          </Flex>
          <Flex flex={1} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Card p={4}>
                <Flex flexDirection="column">
                  <Box>
                    <Heading textAlign="center" mb={4}>
                      Unlock Account
                    </Heading>
                  </Box>

                </Flex>
              </Card>
            </CardContainer>
          </Flex>
        </Container>
        <FullLayout2 />
      </>
    );
  }
  if (invalidUid && isOriginalCheckComplete) {
    return (
      <>
        <Container>
          <Flex flex={1}>
            <Header dark={false} />
          </Flex>
          <Flex flex={1} alignItems="center" justifyContent="center">
            <CardContainer flex={1} px={3}>
              <Card p={4}>
                <Flex flexDirection="column">
                  <Box>
                    <Heading textAlign="center" mb={4}>
                      Unlock Account
                    </Heading>
                    <Text textAlign="center" mb={4}>
                      No Account Found
                    </Text>
                  </Box>
                  <Button variant='primary' onClick={() => {
                    navigate('/')
                  }}>Go Back To Login Page</Button>
                </Flex>
              </Card>
            </CardContainer>
          </Flex>
        </Container>
        <FullLayout2 />
      </>
    );
  }

  if (!isValuesChecked) {
    return (<FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
    <>
      <Container>
        <Flex flex={1} flexDirection="column">
          <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>
            <Heading sx={{ marginLeft: '153px' }}>Providers</Heading>
          </Header>
        </Flex>
        <Flex flex={1} alignItems="center" justifyContent="center">
          <CardContainer flex={1} px={3}>
            <Card p={4}>
              <Flex flexDirection="column">
                <Box mb={4}>
                  <Heading textAlign="center" mb={3}>
                  Unlock Account
                  </Heading>
                </Box>
                <>
                  {!mustEnterOtp ? (
                    <Formik
                      initialValues={{
                        email: '',
                      }}
                      isInitialValid={() => {
                        try {
                          const aa = schema.validateSync({
                            email: '',
                          });

                          if (aa.errors && (aa.errors as any).length) {
                            return false;
                          }
                          return true;
                        } catch (err) {
                          return false;
                        }
                      }}
                      validationSchema={schema}
                      onSubmit={(values) => handleSubmit(values)}
                      render={({ touched, errors, isValid }) => {
                        return (
                          <>
                            <Form>
                              <FormField mb={3} error={touched.email && errors.email}>
                                <TextInput placeholder="Your email address" type="email" name="email" id="input_email" />
                              </FormField>


                              <Flex alignItems="center" flexDirection="column">
                                <Button disabled={!isValid || !!loadingCheckUid || !!loadingCheckUnlockValues || !!loadingUnlock} variant="primary" width={1 / 2} type="submit" id="btn_login">
                                  Continue
                                </Button>
                              </Flex>
                            </Form>

                          </>
                        );
                      }} />
                  ) : (
                    <OtpInner
                      mutate={(otp: any) => {
                        handleSubmit({ ...storedData, otp });
                      }}
                      sendByEmail={() => { }}
                      loading={!!loadingCheckUid || !!loadingCheckUnlockValues || !!loadingUnlock}
                    />
                  )}
                </>
              </Flex>
            </Card>
          </CardContainer>
        </Flex>
      </Container>
    </>
  </FullLayout2>)
  }
  if (!!isValuesChecked) {
    return (<FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
    <>
      <Container>
        <Flex flex={1} flexDirection="column">
          <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>
            <Heading sx={{ marginLeft: '153px' }}>Providers</Heading>
          </Header>
        </Flex>
        <Flex flex={1} alignItems="center" justifyContent="center">
          <CardContainer flex={1} px={3}>
            <Card p={4}>
              <Flex flexDirection="column">
                <Box mb={4}>
                  <Heading textAlign="center" mb={3}>
                  Unlock Account
                  </Heading>
                </Box>
                <>
                  <Formik
                    initialValues={{
                      password: '',
                      passwordConfirm: ''
                    }}
                    isInitialValid={() => {
                      try {
                        const aa = schema.validateSync({
                          email: '',
                          passwordConfirm: ''
                        });

                        if (aa.errors && (aa.errors as any).length) {
                          return false;
                        }
                        return true;
                      } catch (err) {
                        return false;
                      }
                    }}
                    validationSchema={schema2}
                    onSubmit={(values) => handleSubmitReactivate(values)}
                    render={({ touched, errors, isValid }) => {
                      return (
                        <>
                          <Form>

                            <FormField mb={4} error={touched.password && errors.password}>
                              <TextInput placeholder="Password" type="password" name="password" id="input_password" />
                            </FormField>

                            <FormField mb={4} error={touched.passwordConfirm && errors.passwordConfirm}>
                              <TextInput placeholder="Confirm Password" type="password" name="passwordConfirm" id="input_passwordConfirm" />
                            </FormField>


                            <Flex alignItems="center" flexDirection="column">
                              <Button disabled={!isValid || !!loadingCheckUid || !!loadingCheckUnlockValues || !!loadingUnlock} variant="primary" width={1 / 2} type="submit" id="btn_login">
                                Continue
                              </Button>
                            </Flex>
                          </Form>

                        </>
                      );
                    }} />
                </>
              </Flex>
            </Card>
          </CardContainer>
        </Flex>
      </Container>
    </>
  </FullLayout2>)
  }
  return null
}

export default UnlockAccount